// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-boxs[data-v-d6f15e90] .el-checkbox__label {\n  font-size: 14px !important;\n}\n.title-tips[data-v-d6f15e90] {\n  font-size: 12px;\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
